import { configureStore } from "@reduxjs/toolkit";
import connectInBodyReducer from "../slice/phoneNumberSlice";
import smsVerificationCodeInBodyReducer from "../slice/smsVerificationCodeSlice";

//store
const store = configureStore({
  reducer: {
    connectInBody: connectInBodyReducer,
    smsVerificationCodeInBody: smsVerificationCodeInBodyReducer,
  },
});

export default store;
